import Vue from 'vue'
import VueRouter from 'vue-router'
import NProgress from 'nprogress'
import NotFoundComponent from '@/components/generic/404'

Vue.use(VueRouter)

const routes = [
  { path: '*', component: NotFoundComponent },
  {
    path: '/lead/:dealerCode/lcr',
    name: 'LeadCreditApplication',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('@/pages/LeadCreditApplication'),
    props: true,
    meta: { title: 'Credit Application' }
  },
  {
    path: '/lead/creditapplicationcomplete',
    name: 'CreditApplicationComplete',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('@/pages/CreditApplicationComplete'),
    props: false,
    meta: { title: 'Credit Applicaton Completed' }
  },
  {
    path: '/customer/creditapplication',
    name: 'CreditApplication',
    component: () => import('@/pages/CreditApplication'),
    props: (route) => ({ token: route.query.token }),
    meta: { title: 'Credit Application' }
  },
  {
    path: '/customer/creditapplicationcontinuelater',
    name: 'CreditApplicationContinueLater',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('@/pages/CreditApplicationContinueLater'),
    props: false,
    meta: { title: 'Credit Applicaton Completed' }
  },
  {
    path: '/customer/creditapplicationcancelled',
    name: 'CreditApplicationCancelled',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('@/pages/CreditApplicationCancelled'),
    props: false,
    meta: { title: 'Credit Applicaton Cancelled' }
  },
  {
    path: '/lead/:dealerCode/blcr',
    name: 'BusinessLeadCreditApplication',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('@/pages/BusinessLeadCreditApplication'),
    props: true,
    meta: { title: 'Business Credit Application' }
  },
  {
    path: '/customer/businesscreditapplication',
    name: 'BusinessCreditApplication',
    component: () => import('@/pages/BusinessCreditApplication'),
    props: (route) => ({ token: route.query.token }),
    meta: { title: 'Business Credit Application' }
  },
  {
    path: '/customer/identityverification',
    name: 'IdentityVerification',
    component: () => import('@/pages/IdentityVerification'),
    props: (route) => ({ token: route.query.token }),
    meta: { title: 'Confirm your information' }
  },
  {
    path: '/customer/identityverificationcomplete',
    name: 'IdentityVerificationComplete',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('@/pages/IdentityVerificationComplete'),
    props: false,
    meta: { title: 'Customer Identity Verification Completed' }
  },
  {
    path: '/customer/identityverificationcontinuelater',
    name: 'IdentityVerificationContinueLater',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('@/pages/IdentityVerificationContinueLater'),
    props: false,
    meta: { title: 'Customer Identity Verification Completed' }
  },
  {
    path: '/supplier/identityverification',
    name: 'SupplierIdentityVerification',
    component: () => import('@/pages/SupplierIdentityVerification'),
    props: (route) => ({ token: route.query.token }),
    meta: { title: 'Confirm your information' }
  },
  {
    path: '/supplier/identityverificationcomplete',
    name: 'SupplierIdentityVerificationComplete',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('@/pages/SupplierIdentityVerificationComplete'),
    props: false,
    meta: { title: 'Supplier Identity Verification Completed' }
  },
  {
    path: '/supplier/identityverificationcontinuelater',
    name: 'SupplierIdentityVerificationContinueLater',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('@/pages/SupplierIdentityVerificationContinueLater'),
    props: false,
    meta: { title: 'Supplier Identity Verification Completed' }
  },
  {
    path: '/supplier/vehicleverification',
    name: 'SupplierVehicleVerification',
    component: () => import('@/pages/SupplierVehicleVerification'),
    props: (route) => ({ token: route.query.token }),
    meta: { title: 'Supplier Vehicle Verification' }
  },
  {
    path: '/supplier/vehicleverificationcomplete',
    name: 'SupplierVehicleVerificationComplete',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('@/pages/SupplierVehicleVerificationComplete'),
    props: false,
    meta: { title: 'Supplier Vehicle Verification Complete' }
  },
  {
    path: '/print/printrequest',
    name: 'PrintRequest',
    component: () => import('@/pages/PrintRequest'),
    props: (route) => ({ token: route.query.token }),
    meta: { title: 'Print Request' }
  },
  {
    name: 'PrintRequestComplete',
    path: '/print/printrequestcomplete/:id',
    component: () => import('@/pages/PrintRequestComplete'),
    meta: { title: 'Print Request Complete' }
  },
  {
    name: 'PrintRequestTerms',
    path: '/print/printrequestterms',
    component: () => import('@/pages/PrintRequestTerms'),
    meta: { title: 'Print Request Terms and Conditions' }
  },
  {
    path: '/customer/documentverification',
    name: 'DocumentVerification',
    component: () => import('@/pages/CustomerDocumentationVerification'),
    props: (route) => ({ token: route.query.token }),
    meta: { title: 'Confirm your documentation' }
  },
  {
    path: '/customer/documentverificationcomplete',
    name: 'CustomerDocumentVerificationComplete',
    component: () => import('@/pages/CustomerDocumentVerificationComplete'),
    props: false,
    meta: { title: 'Customer Document Verification Completed' }
  },
  {
    path: '/valet/updatestatus',
    name: 'ValetStatus',
    component: () => import('@/pages/ValetStatusUpdate'),
    props: (route) => ({ token: route.query.token }),
    meta: { title: 'Valet Status' }
  },
  {
    path: '/valet/valetstatusupdatecomplete',
    name: 'ValetStatusUpdateComplete',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('@/pages/ValetStatusUpdateComplete'),
    props: false,
    meta: { title: 'Vehicle Washing Status Update Complete' }
  },
  {
    path: '/vehiclewashing/updatestatus',
    name: 'VehicleWashingStatus',
    component: () => import('@/pages/VehicleWashingStatusUpdate'),
    props: (route) => ({ token: route.query.token }),
    meta: { title: 'Vehicle Washing Status' }
  },
  {
    path: '/vehiclewashing/vehiclewashingstatusupdatecomplete',
    name: 'VehicleWashingStatusUpdateComplete',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('@/pages/VehicleWashingStatusUpdateComplete'),
    props: false,
    meta: { title: 'Vehicle Washing Status Update Complete' }
  },
  {
    path: '/inventory/supplier/getinventoryinformation',
    name: 'InventorySupplierInformation',
    component: () => import('@/pages/InventorySupplierViewInformation'),
    props: (route) => ({ token: route.query.token }),
    meta: { title: 'Vehicle Information' }
  },
  {
    path: '/inventory/customer/getinventoryinformation',
    name: 'InventoryCustomerInformation',
    component: () => import('@/pages/InventoryCustomerViewInformation'),
    props: (route) => ({ token: route.query.token }),
    meta: { title: 'Vehicle Information' }
  },
  {
    path: '/servicevideo/supplier/getservicevideoinformation',
    name: 'ServiceVideoSupplierInformation',
    component: () => import('@/pages/ServiceVehicleSupplierViewInformation'),
    props: (route) => ({ token: route.query.token }),
    meta: { title: 'Vehicle Information' }
  },
  {
    path: '/servicevideo/customer/getservicevideoinformation',
    name: 'ServiceVideoCustomerInformation',
    component: () => import('@/pages/ServiceVehicleCustomerViewInformation'),
    props: (route) => ({ token: route.query.token }),
    meta: { title: 'Vehicle Information' }
  },
  {
    path: '/carfax/callback',
    name: 'CarfaxCallback',
    component: () => import('@/pages/CarfaxCallback'),
    props: (route) => ({ code: route.query.code, state: route.query.state }),
    meta: { title: 'CARFAX Callback' }
  },
  {
    path: '/carfax/callbackcompleted',
    name: 'CarfaxCallbackCompleted',
    component: () => import('@/pages/CarfaxCallbackCompleted'),
    props: false,
    meta: { title: 'CARFAX Callback Completed' }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeResolve((to, from, next) => {
  if (to.name) {
    NProgress.start()
    next()
  } else {
    next()
  }
})

router.afterEach((to, from) => {
  NProgress.done()
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

export default router
